//the connect utility helps us map the state to react component's props
import { connect } from 'react-redux';

import { hashHistory } from 'react-router'

import EmploymentHistory from "./EmploymentHistory.jsx";

import getSavedApp from 'utils/load-application';

const mapStateToProps = (state) => {
	return {
		config: state.config,
		values: state.form['employment-application'] ? state.form['employment-application'].values : {},
		initialValues: getSavedApp()
	};
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onSubmit: () => hashHistory.push("complete"),
		goToPrevious: () => hashHistory.push("education")
	};
}

const EmploymentHistoryContainer = connect(
  mapStateToProps,
	mapDispatchToProps
)(EmploymentHistory);


export default EmploymentHistoryContainer;
